import { useReduxState } from 'hooks';
import { Alert } from 'components/common';
import { TwoFactorBackupCodes } from '.';

interface Props {
  isSharedConfigured?: boolean;
}

const TwoFactorSuccess = ({ isSharedConfigured }: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="success">
      <Alert text={messages.authTwoFactorSetupSuccess} type="success-light" />

      <div className="backup-codes">
        <TwoFactorBackupCodes
          isSharedConfigured={isSharedConfigured}
          requireAuthentication={false}
        />
      </div>

      <style jsx>{`
        .success {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 400;
        }
        .icon {
          background-color: ${theme.successColor};
          border-radius: 100px;
          color: ${theme.successTextColor};
          display: inline-block;
          font-size: 1.8rem;
          padding: 10px 0;
          text-align: center;
          width: 40px;
          height: 40px;
        }
        .title {
          font-size: 1.8rem;
          font-weight: 600;
          margin: 10px 0 5px;
        }
        .backup-codes {
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default TwoFactorSuccess;
